import React, { useEffect, useRef } from 'react';
import './HowItWorks.css';
import ScrollFloat from './ScrollFloat';

const HowItWorks = ({
  title = "Ako to funguje",
  subtitle = "Tri jednoduché kroky k revolúcii vo vašom dispečingu",
  cards = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" x2="12" y1="19" y2="22"/>
          <line x1="8" x2="16" y1="22" y2="22"/>
        </svg>
      ),
      title: "AI rozumie. Vždy.",
      subtitle: "Hlas na text",
      description: "Dispečerský bot premení prirodzenú slovenskú reč na presné údaje o jazde. Zachytí adresy, slang aj emócie. Žiadna požiadavka nezostane nepochopená.",
      highlights: ["adresy", "slang", "emócie"]
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 2v4"/>
          <path d="M16 2v4"/>
          <rect width="18" height="18" x="3" y="4" rx="2"/>
          <path d="M3 10h18"/>
          <path d="M8 14h.01"/>
          <path d="M12 14h.01"/>
          <path d="M16 14h.01"/>
          <path d="M8 18h.01"/>
          <path d="M12 18h.01"/>
          <path d="M16 18h.01"/>
        </svg>
      ),
      title: "Žiadne čakanie. Len jazda.",
      subtitle: "Upozornenia pre taxíky",
      description: "Systém okamžite pingne najbližších vodičov. Tí môžu jazdu prijať alebo odmietnuť. Kto klikne prvý, ide. Jednoduché, férové, rýchle.",
      highlights: ["prijať", "odmietnuť"]
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="20" height="14" x="2" y="7" rx="2" ry="2"/>
          <circle cx="8" cy="21" r="1"/>
          <circle cx="19" cy="21" r="1"/>
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
        </svg>
      ),
      title: "Flexibilita pre váš biznis.",
      subtitle: "Mesačné balíky",
      description: "Služba funguje na mesačných balíkoch od 49 € – podľa veľkosti firmy. Žiadne zmluvy, žiadne skryté poplatky. Len čistá kontrola nad dispečingom.",
      highlights: ["49 €"]
    }
  ]
}) => {
  const renderDescription = (description, highlights) => {
    if (!highlights || highlights.length === 0) return description;
    
    let result = description;
    highlights.forEach(highlight => {
      result = result.replace(
        new RegExp(`\\b${highlight}\\b`, 'gi'),
        `<span class="highlight">${highlight}</span>`
      );
    });
    
    return <span dangerouslySetInnerHTML={{ __html: result }} />;
  };

  return (
    <section className="how-it-works" id="ako-to-funguje">
      <div className="container">
        <ScrollFloat
          animationDuration={1}
          ease='back.inOut(2)'
          scrollStart='center bottom+=50%'
          scrollEnd='bottom bottom-=40%'
          stagger={0.03}
          containerClassName="section-title-scroll"
        >
          {title}
        </ScrollFloat>
        <p className="section-subtitle scroll-reveal scroll-reveal-delay-1">{subtitle}</p>
        
        <div className="how-it-works-grid">
          {cards.map((card, index) => (
            <div key={index} className={`how-card scroll-reveal scroll-reveal-delay-${index + 2}`}>
              <div className="how-card-icon">
                {card.icon}
              </div>
              <h3>{card.title}</h3>
              <h4>{card.subtitle}</h4>
              <p>
                {renderDescription(card.description, card.highlights)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 